import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.reduce";
import { parseDate } from "../interface";
export default function shouldComponentUpdate(nextProps, nextState) {
  var _this = this;

  var shouldUpdate = (nextProps.selected || []).reduce(function (prev, next, i) {
    var currentSelected = (_this.props.selected || [])[i];

    if (!currentSelected || !next || parseDate(currentSelected).getTime() !== parseDate(next).getTime()) {
      return {
        update: true,
        field: 'selected'
      };
    }

    return prev;
  }, {
    update: false
  });
  shouldUpdate = ['markedDates', 'hideExtraDays', 'displayLoadingIndicator'].reduce(function (prev, next) {
    if (!prev.update && nextProps[next] !== _this.props[next]) {
      return {
        update: true,
        field: next
      };
    }

    return prev;
  }, shouldUpdate);
  shouldUpdate = ['minDate', 'maxDate', 'current'].reduce(function (prev, next) {
    var prevDate = parseDate(_this.props[next]);
    var nextDate = parseDate(nextProps[next]);

    if (prev.update) {
      return prev;
    } else if (prevDate !== nextDate) {
      if (prevDate && nextDate && prevDate.getTime() === nextDate.getTime()) {
        return prev;
      } else {
        return {
          update: true,
          field: next
        };
      }
    }

    return prev;
  }, shouldUpdate);

  if (nextState.currentMonth !== this.state.currentMonth) {
    shouldUpdate = {
      update: true,
      field: 'current'
    };
  }

  return shouldUpdate.update;
}

if (typeof shouldComponentUpdate !== 'undefined' && shouldComponentUpdate && shouldComponentUpdate === Object(shouldComponentUpdate) && Object.isExtensible(shouldComponentUpdate) && !shouldComponentUpdate.hasOwnProperty('__filemeta')) {
  Object.defineProperty(shouldComponentUpdate, '__filemeta', {
    configurable: true,
    value: {
      name: "shouldComponentUpdate",
      filename: "node_modules/react-native-calendars/src/calendar/updater.js"
    }
  });
}